import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useDarkMode } from '../darkmode/DarkModeContext';

const Paket = () => {
  const { isDarkMode } = useDarkMode();
  const navigate = useNavigate();

  const packages = [
    {
      _id: '68b086ef5e9bea64abc06a95',
      speed: '20 Mbps',
      name: 'Telnet Home Promo Paket Bulanan',
      price: 'Rp 199.000',
      period: '/bln',
      desc: 'Perfect untuk streaming HD dan browsing keluarga',
      badge: 'PROMO',
      badgeColor: 'bg-[#1E9B4C]',
      features: ['10 devices', 'Unlimited data', 'Support 24/7', 'Free installation']
    },
    {
      _id: '68b086ef5e9bea64abc06a96',
      speed: '100 Mbps',
      name: 'Telnet Home Promo Paket Bulanan',
      price: 'Rp 399.000',
      period: '/bln',
      desc: 'Ideal untuk gaming dan streaming 4K multiple device',
      badge: 'POPULER',
      badgeColor: 'bg-green-600',
      features: ['20 devices', 'Unlimited data', 'Priority support', 'Free router']
    },
    {
      _id: '68b086ef5e9bea64abc06a97',
      speed: '30 Mbps',
      name: 'Telnet Home Gaming Bundling 3 Bulan',
      price: 'Rp 299.000',
      period: '/bln',
      desc: 'Zero lag gaming dengan ping <10ms',
      badge: 'GAMING',
      badgeColor: 'bg-purple-600',
      features: ['30+ devices', 'Unlimited data', 'Gaming optimization', 'Static IP']
    },
    {
      _id: '68b086ef5e9bea64abc06a98',
      speed: '100 Mbps',
      name: 'Telnet Home Bisnis Dedicated',
      price: 'Rp 899.000',
      period: '/bln',
      desc: 'Bandwidth Dedicated dengan SLA 99.9%',
      badge: 'BISNIS',
      badgeColor: 'bg-gray-700',
      features: ['Custom devices', 'Unlimited data', 'Dedicated support', 'SLA 99.9%']
    }
  ];

  const handlePackageSelect = (pkg) => {
    navigate('/coverage-check', {
      state: { selectedPackage: pkg, fromPackageSelection: true }
    });
  };

  return (
    <div className="py-16">
      <div className="section-container">
        <div className="text-center mb-10">
          <h2 className={`text-3xl font-bold mb-3 ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>
            Paket Populer
          </h2>
          <p className={`max-w-2xl mx-auto text-sm ${isDarkMode ? 'text-gray-400' : 'text-gray-600'}`}>
            Pilih paket internet yang sesuai dengan kebutuhan Anda.
          </p>
        </div>

        <div className="flex md:grid md:grid-cols-2 lg:grid-cols-4 gap-4 overflow-x-auto pb-4 md:overflow-visible md:pb-0 snap-x snap-mandatory scrollbar-hide">
          {packages.map((pkg, index) => (
            <div
              key={index}
              className={`card-base p-5 flex flex-col w-[280px] md:w-auto flex-shrink-0 md:flex-shrink snap-start  ${
                isDarkMode ? 'bg-gray-800 border-gray-700' : 'bg-white'
              }`}
      
            >
              <div className="flex justify-between items-start mb-3">
                <div className="text-xl font-bold text-[#1E9B4C]">{pkg.speed}</div>
                <span className={`${pkg.badgeColor} text-white px-2 py-0.5 rounded-lg text-[10px] font-semibold tracking-wide`}>
                  {pkg.badge}
                </span>
              </div>

              <div className={`font-semibold text-sm mb-1 ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>
                {pkg.name}
              </div>

              {/* Price */}
              <div className="mb-3">
                <span className={`text-2xl font-bold ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>{pkg.price}</span>
                <span className={`text-xs ${isDarkMode ? 'text-gray-400' : 'text-gray-500'}`}>{pkg.period}</span>
              </div>

              <div className={`text-xs mb-4 ${isDarkMode ? 'text-gray-400' : 'text-gray-500'}`}>
                {pkg.desc}
              </div>

              <div className="mb-5 flex-grow space-y-2">
                {pkg.features.map((feature, i) => (
                  <div key={i} className="flex items-center">
                    <div className="w-4 h-4 bg-[#1E9B4C] rounded-full flex items-center justify-center mr-2 flex-shrink-0">
                      <span className="text-white text-[9px]">✓</span>
                    </div>
                    <span className={`text-xs ${isDarkMode ? 'text-gray-300' : 'text-gray-600'}`}>{feature}</span>
                  </div>
                ))}
              </div>

              <button
                onClick={() => handlePackageSelect(pkg)}
                className="btn-primary w-full text-center text-sm py-2.5"
              >
                Cek Wilayah
              </button>
            </div>
          ))}
        </div>

        <div className="md:hidden text-center mt-3">
          <p className={`text-xs ${isDarkMode ? 'text-gray-500' : 'text-gray-400'}`}>
            ← Geser untuk melihat paket lainnya →
          </p>
        </div>
      </div>
    </div>
  );
};

export default Paket;
